var _circle, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewJobBoardSwv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 13,
    fill: "#FFEFE8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.01075 12.5294C9.31709 12.5294 9.61089 12.6534 9.8275 12.874C10.0441 13.0946 10.1658 13.3939 10.1658 13.7059V14.8824H15.9411V13.7059C15.9411 13.3939 16.0628 13.0946 16.2794 12.874C16.496 12.6534 16.7898 12.5294 17.0962 12.5294C17.4025 12.5294 17.6963 12.6534 17.9129 12.874C18.1295 13.0946 18.2512 13.3939 18.2512 13.7059V16.0588C18.2512 16.3708 18.1295 16.6701 17.9129 16.8907C17.6963 17.1113 17.4025 17.2353 17.0962 17.2353H9.01075C8.70441 17.2353 8.41062 17.1113 8.19401 16.8907C7.97739 16.6701 7.8557 16.3708 7.8557 16.0588V13.7059C7.8557 13.3939 7.97739 13.0946 8.19401 12.874C8.41062 12.6534 8.70441 12.5294 9.01075 12.5294V12.5294Z",
    stroke: "#FF6019",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.74579 12.5294V8.76471C9.74579 8.36057 9.95737 7.61444 10.334 7.32867C10.7106 7.0429 11.2214 6.88235 11.754 6.88235H14.3529C14.8855 6.88235 15.3963 7.0429 15.7729 7.32867C16.1495 7.61444 16.3611 8.36057 16.3611 8.76471V12.5294",
    stroke: "#FF6019",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.037 17.6673V19.0006",
    stroke: "#FF6019",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0699 17.6673V19.0006",
    stroke: "#FF6019",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6359 10.6471H14.471",
    stroke: "#FF6019",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewJobBoardSwv);
export default __webpack_public_path__ + "static/media/NewJobBoardSWV.4292e2d8.svg";
export { ForwardRef as ReactComponent };